<template>
  <div
    :class="{
      'flex h-full flex-col rounded border border-b-5px border-www-color-neutral-very-light border-b-www-color-primary-lighter bg-www-color-white p-30px shadow-card': true,
    }"
  >
    <div :class="{ 'mb-4 flex justify-between': true }">
      <div class="rate">
        <img
          v-if="starRating == 5"
          :src="fiveStarSrc"
          alt="5 stars"
        />
        <img
          v-else-if="starRating == 4.5"
          :src="fourStarSrc"
          alt="4.5 stars"
        />
      </div>
      <div :class="{ 'flex items-center gap-2': true }">
        <GeneralLink
          v-if="link"
          :class="{ 'font-ptc-Rajdhani text-base font-bold text-www-color-primary-lighter': true }"
          v-bind="link"
        />
        <img
          :src="arrowSrc"
          alt="arrow icon"
        />
      </div>
    </div>
    <p :class="{ 'mb-5 text-base text-www-color-neutral-medium-dark': true }">{{ review }}</p>

    <div :class="{ 'mt-auto text-www-color-neutral-medium': true }">
      <h4 :class="{ 'text-sm font-bold': true }">{{ reviewerName }}</h4>
      <h4 :class="{ 'text-xs font-medium': true }">{{ industryTitle }}</h4>
      <p :class="{ 'text-xs font-normal italic': true }">{{ businessSize }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ReviewCard } from '~/sanity/types';
import GeneralLink from '../HeaderComponents/GeneralLink.vue';
const { $staticImages } = useNuxtApp();
const fiveStarSrc = $staticImages['star5'];
const fourStarSrc = $staticImages['star45'];
const arrowSrc = $staticImages['arrow'];

defineProps<ReviewCard>();
</script>

<style scoped></style>
